/**
 * Author: Marek Zeman
 * Twitter: MarekZeman91
 * License: MIT
 * Version: 1.01
 * Revision: 20.7.2016 // Better support for minification
 *
 *
 * Adapated to ES6 by Jeremy P - FCINQ
 * Some fixs are stolen from Zepto code source
 */

let delegated = {};

function get(type, selector, useCapture) {
    let cache = delegated, args = arguments;
    let i, l = args.length;
    for (i = 0; i < l && cache; i++) {
        cache = cache[args[i]];
    }
    return cache;
}

function set(type, selector, useCapture, item) {
    let cache = delegated, args = arguments;
    let i, l = args.length - 1;
    for (i = 0; i < l; i++) cache = cache[args[i]] || (
        cache[args[i]] = i + 1 === l ? [] : {}
    );
    return (cache.push(item), item);
}

let proto = Element.prototype;
let matchesFn = 'MatchesSelector';
let matches = (
    proto.matches ||
    proto['o' + matchesFn] ||
    proto['ms' + matchesFn] ||
    proto['moz' + matchesFn] ||
    proto['webkit' + matchesFn]
);

function targetHandler(event, selector, listener) {
    let target = event.target;

    do {
        if (!(target instanceof Element)) return;
        if (!matches.call(target, selector)) {
            target = target.parentNode;
            continue;
        }
        let evt = createProxy(event);
        evt.currentTarget = target;

        if (listener.handleEvent) {
            listener.handleEvent.call(listener, evt);
        }
        else {
            listener.apply(this, [evt]);
        }
        return;
    }
    while (target && target !== this);
}

var returnTrue = function () {
        return true
    },
    returnFalse = function () {
        return false
    },
    ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,
    eventMethods = {
        preventDefault: 'isDefaultPrevented',
        stopImmediatePropagation: 'isImmediatePropagationStopped',
        stopPropagation: 'isPropagationStopped'
    };



function compatible(event, source) {
    if (source || !event.isDefaultPrevented) {
        source || (source = event);
        for( let name in eventMethods) {
            (function(name, predicate) {
                let sourceMethod = source[name];
                event[name] = function () {
                    this[predicate] = returnTrue;
                    return sourceMethod && sourceMethod.apply(source, arguments)
                };
                event[predicate] = returnFalse
            })(name, eventMethods[name]);
        }

        try {
            event.timeStamp || (event.timeStamp = Date.now())
        } catch (ignored) {
        }

        if (source.defaultPrevented !== undefined ? source.defaultPrevented :
            'returnValue' in source ? source.returnValue === false :
                source.getPreventDefault && source.getPreventDefault())
            event.isDefaultPrevented = returnTrue
    }
    return event
}

function createProxy(event) {
    var key, proxy = {originalEvent: event};
    for (key in event)
        if (!ignoreProperties.test(key) && event[key] !== undefined) proxy[key] = event[key]

    return compatible(proxy, event)
}

export function delegateEventListener(elmt, type, selector, listener, useCapture) {
    let obj = {selector: selector, listener: listener};
    elmt.addEventListener(type, obj.handler = function (event) {
        targetHandler.call(this, event, selector, listener);
    }, useCapture);
    set(type, selector, useCapture, obj);
}

export function undelegateEventListener(elmt, type, selector, listener, useCapture) {
    let cache = get(type, selector, useCapture);
    for (let i = 0; (cache || [])[i]; i++) {
        if (cache[i].listener !== listener) continue;
        elmt.removeEventListener(type, cache[i].handler, useCapture);
        cache.splice(i--, 1);
    }
}